import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from 'common/method/handleNotificationAlert'

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
    selectStockSummaries: "selectStockSummaries [Action]",
    selectStockSummariesLoading: "selectStockSummariesLoading [Action]",
    selectStockSummariesAsync: "selectStockSummariesAsync [Action]",
};
const inistiaState = {
    data: [],
    loading: false,
    total:0
};

export const select_Stock_Summaries_Reducer = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.selectStockSummaries:
            return {
                ...state,
                data: payload?.results,
                total: payload?.total,
            };
        case actionTypes.selectStockSummariesLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectStockSummariesLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "stock",
        method_type: "select_summaries",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }
        yield put({ type: actionTypes.selectStockSummaries, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectStockSummariesLoading, payload: false })

    }
}

export function* selectStockSummaries() {
    yield takeLatest(actionTypes.selectStockSummariesAsync, handleWorker);
}
